// Tiny DOM helpers shared across the app (auth gate, shell, feature screens).
//
// Kept dependency-free and framework-free: `h` builds elements declaratively and
// `clear`/`mount` swap content. These were originally inline in app.js; extracted
// here so the shell (task 3.5) and the feature screens (task 3.6) reuse the same
// primitives instead of duplicating them.

// Build a DOM element. `attrs` supports:
//   class:  className
//   text:   textContent (convenience)
//   onX:    an event listener for event "x" (e.g. onclick, onsubmit)
//   other:  setAttribute; a `true` value renders as a bare/empty attribute, and
//           null/false/undefined values are skipped entirely.
// `children` may be a single node/string or an array; strings become text nodes
// and null/undefined children are ignored.
export function h(tag, attrs = {}, children = []) {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v == null || v === false) continue;
    if (k === 'class') node.className = v;
    else if (k === 'text') node.textContent = v;
    else if (k.startsWith('on') && typeof v === 'function') node.addEventListener(k.slice(2), v);
    else node.setAttribute(k, v === true ? '' : v);
  }
  for (const child of [].concat(children)) {
    if (child == null) continue;
    node.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
  }
  return node;
}

// Remove every child of a node.
export function clear(node) {
  while (node.firstChild) node.removeChild(node.firstChild);
}

// Replace a container's contents with a single node (or nothing).
export function mount(container, node) {
  clear(container);
  if (node != null) container.appendChild(node);
  return container;
}
